const dic = {
  // 公共
  solutionMode: {
    //解算模式，差分模式
    0: '单基站',
    1: '组网',
  },
  // 定位状态，解算状态,最新解算状态
  positionStatus: {
    0: '定位无效',
    1: '单点定位',
    2: 'DGNSS',
    4: 'RTK固定解',
    5: 'RTK浮点解',
    6: '纯惯导定位',
    7: '用户设定位置',
  },
  // 账号列表
  expireStatus: {
    //过期状态，
    0: '未激活',
    1: '正常使用',
    2: '已过期',
  },
  mountType: {
    // 数据类型
    1: 'RTCM2.X',
    2: 'RTCM3.X',
  },
  mountDataTypeList: {
    // 数据类型具体内容
    RTCM2: [
      { title: 'TYPE1', value: 'rtcm23Type1' },
      { title: 'TYPE3', value: 'rtcm23Type3' },
      { title: 'TYPE1819', value: 'rtcm23Type1819' },
      { title: 'TYPE31', value: 'rtcm23Type31' },
      { title: 'TYPE41 GPS', value: 'rtcm23Type41Gps' },
      { title: 'TYPE41 GLO', value: 'rtcm23Type41Glo' },
      { title: 'TYPE41 BDS', value: 'rtcm23Type41Bds' },
      { title: 'TYPE41 GAL', value: 'rtcm23Type41Gal' },
    ],
    RTCM3: [
      { title: 'GPS', value: 'rtcm32Gps' },
      { title: 'GPS MSM', value: 'rtcm32GpsMsm' },
      { title: 'GLO', value: 'rtcm32Glo' },
      { title: 'GLO MSM', value: 'rtcm32GLOMsm' },
      { title: 'BDS', value: 'rtcm32Bds' },
      { title: 'BDS MSM', value: 'rtcm32BdsMsm' },
      { title: 'GAL', value: 'rtcm32Gal' },
      { title: 'GAL MSM', value: 'rtcm32GalMsm' },
      { title: '1005', value: 'rtcm321005' },
      { title: '1007', value: 'rtcm321007' },
      { title: '1033', value: 'rtcm321033' },
      { title: 'GPS(1004)', value: 'rtcm321004' },
      { title: 'GLO(1012)', value: 'rtcm321012' },
    ],
  },
  diffMode: {
    // 差分数据模式
    1: '单基站',
    2: '格网虚拟站',
    3: '临时虚拟站',
    4: '指定单基站',
  },
  useFlag: {
    //坐标系使用状态
    0: '未使用',
    1: '使用中',
  },
  // 定位状态
  positionStatusUrl: {
    0: 'yuandian9.png',
    1: 'yuandian.png',
    2: 'yuandian2.png',
    4: 'yuandian4.png',
    5: 'yuandian5.png',
    6: 'yuandian6.png',
    7: 'yuandian8.png',
  },
  // 站点管理
  stationType: {
    //站点类型
    0: '基准站',
    1: 'RTK无人机',
    2: '杆塔沉降终端',
    3: '导线弧垂终端',
  },
  stationStatus: {
    //站点状态，在线状态
    0: '离线',
    1: '在线',
  },
  protocol: {
    // 连接类型
    tcpClient: 'TCPClient',
    tcpServer: 'TCPServer',
    ntripServer: 'NtripServer',
    ntripClient: 'NtripClient',
  },
  solutionType: {
    // 解算类型
    1: 'rtk实时解算',
    2: '事后解算',
  },

  rinexType: {
    //	rinex类型
    0: '观测文件',
    1: '导航电文文件',
  },
  statusCompress: {
    //文件压缩状态，
    0: '不压缩',
    1: '已压缩',
  },
  statusUpload: {
    //文件上传状态，
    0: '未上传',
    1: '已上传',
  },
  // 运行状况
  dataStatus: {
    //数据状态
    0: '异常',
    1: '正常',
  },
  networkStatus: {
    //网络状态，
    0: '断线',
    1: '在线',
  },
};
export default dic;
